import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { database, signOut } from '../firebaseConfig';
import { ref, get } from 'firebase/database';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../HomePage.css';



const HomePage = () => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setLoading(true); // Show loader while fetching data
      setUser(currentUser);

      if (currentUser) {
        try {
          const userRef = ref(database, `users/${currentUser.uid}`);
          const snapshot = await get(userRef);
          if (snapshot.exists()) {
            setIsAdmin(snapshot.val()?.isAdmin || false);
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      } else {
        setIsAdmin(false);
      }
      setLoading(false); // Hide loader once data is fetched
    });

    return () => unsubscribe();
  }, [auth]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null);
      setIsAdmin(false);
    } catch (error) {
      console.error('Error logging out:', error.message);
    }
  };

  return (
    <div
      className="d-flex flex-column align-items-center homepage-container"
    >
      <div className="content-box">
        {loading ? (
          <div className="loading-spinner">
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <h1 className="text-center homepage-title">
              <i className="bi bi-lightbulb-fill"></i> Welcome to{' '}
              <span>PRAGYESH IAS</span>
            </h1>
            <p className="text-center homepage-subtitle">
             <span> Unlock the future of education with</span>{' '}
              <span>technology-driven learning</span>.
            </p>

            {/* Responsive Block Layout with Hover Animation */}
            <div className="row mt-4">
              <div className="col-12 col-md-4 mb-3">
                <div className="info-card">
                  <i className="bi bi-display"></i>
                  <h3>Virtual Classrooms</h3>
                  <p>Seamless, immersive, and interactive online learning experiences.</p>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-3">
                <div className="info-card">
                  <i className="bi bi-globe"></i>
                  <h3>Learn Anywhere</h3>
                  <p>Connect with global educators and peers from the comfort of your home.</p>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-3">
                <div className="info-card">
                  <i className="bi bi-rocket-takeoff"></i>
                  <h3>Empowering Tools</h3>
                  <p>Leverage AI-driven tools and resources for personalized education.</p>
                </div>
              </div>
            </div>

            {user ? (
              <div className="mt-4 text-center user-section">
                <img
                  src={user.photoURL || 'https://via.placeholder.com/150'}
                  alt={user.displayName || 'User'}
                  className="user-avatar"
                />
                <h2>Hello, {user.displayName || 'User'}!</h2>
                <div className="d-grid gap-2 mt-3">
                  <Link to="/student" className="btn btn-success">
                    <i className="bi bi-book"></i> Explore as Student
                  </Link>
                  {isAdmin && (
                    <Link to="/admin" className="btn btn-warning">
                      <i className="bi bi-gear"></i> Access Mentor Panel
                    </Link>
                  )}
                  <button className="btn btn-danger" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right"></i> Logout
                  </button>
                </div>
              </div>
            ) : (
              <div className="text-center mt-4">
                <p>Join us today and start your journey!</p>
                <Link to="/login" className="btn btn-primary">
                  <i className="bi bi-person-plus"></i> Get Started
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default HomePage;
